import styled from "styled-components"

export const Container = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
`

export const Pages = styled.div<{ currentPage: boolean }>`
  min-width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border: ${(props) => `1px solid ${props.theme.colors.text}`};
  border-radius: 5px;
  background-color: ${(props) =>
    props.currentPage ? props.theme.colors.primaryBlue : "#fff"};
  color: ${(props) => (props.currentPage ? "#fff" : props.theme.colors.text)};
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
`

export const ScrollContainer = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  max-width: 80vw;
  padding: 10px 0;
  scroll-behavior: smooth;

  /* Oculta scrollbar no Chrome, Safari e Edge */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Oculta scrollbar no Firefox */
  scrollbar-width: none;
`

export const ArrowButton = styled.button`
  background: none;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 16px;
  margin: 0 5px;
  color: ${(props) => props.theme.colors.text};
`
